import deburr from 'lodash/deburr';
import words from 'lodash/words';

/** Used to match words to create compound words. */
const reWords = (function() {
  const upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]';
  const lower = '[a-z\\xdf-\\xf6\\xf8-\\xff0-9]+';

  return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper, 'g');
}());

export default function snakeCase(string) {
  let index = -1;
  const array = words(deburr(string), reWords);
  const length = array.length;
  let result = '';

  while (++index < length) {
    result = handleWorld(result, array[index], index);
  }
  return result;
}

function handleWorld(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
}




// WEBPACK FOOTER //
// ./src/utils/snake-case.util.js